import { LOGO_LIST_FAIL,
         LOGO_LIST_REQUEST,
         LOGO_LIST_SUCCESS } from "../constants/logoConstansts"




export const listLogoReducers = (state = {logoImage:[]} , action) => {
    switch(action.type){
        case LOGO_LIST_REQUEST:
            return { logoImage: [] , loading: true}
        case LOGO_LIST_SUCCESS:
            return { logoImage: action.payload , loading: false}
        case LOGO_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}





